export default {
  init() {
    // JavaScript to be fired on all pages
    // Burger menu close on url change
    const scrollLink = document.querySelectorAll('.scroll-link');

    scrollLink.forEach(element => {
        element.addEventListener('click', () => {
          noScroll.style.overflow = 'visible';
          burgerMenuContent.classList.remove('active');
          burgerOpenIcon.classList.add('active');
          burgerCloseIcon.classList.remove('active');
      })
    });

    // Burger Menu JavaScript
    const burgerOpenIcon = document.querySelector('.burger-open-icon');
    const burgerCloseIcon = document.querySelector('.burger-close-icon');
    const burgerMenuContent = document.querySelector('.burger-menu-content');
    const noScroll = document.body;

    burgerOpenIcon.addEventListener('click', () => {
      burgerOpenIcon.classList.toggle('active');
      burgerMenuContent.classList.toggle('active');
      burgerCloseIcon.classList.toggle('active');
      noScroll.style.overflow = 'hidden';
    })

    burgerCloseIcon.addEventListener('click', () => {
      burgerMenuContent.classList.toggle('active');
      burgerOpenIcon.classList.toggle('active');
      burgerCloseIcon.classList.toggle('active');
      marketsDropDownContent.classList.remove('active');
      marketsDropDownArrow.classList.remove('rotate');
      servicesDropDownContent.classList.remove('active');
      servicesDropDownArrow.classList.remove('rotate');
      noScroll.style.overflow = 'visible';
    })
    // Burger Menu JavaScript

    // Burger drop down for services JavaScript
    const servicesDropDown = document.querySelector('.services-drop-down-phone');
    const servicesDropDownContent = document.querySelector('.services-drop-down-content-phone');
    const servicesDropDownArrow = document.querySelector('.services-drop-down-arrow');

    servicesDropDown.addEventListener('click', () => {
      servicesDropDownContent.classList.toggle('active');
      servicesDropDownArrow.classList.toggle('rotate');

      if(marketsDropDownContent.classList.contains('active')){
        marketsDropDownContent.classList.remove('active');
        marketsDropDownArrow.classList.remove('rotate');
      }
      else {
        return;
      }
    })
    // Burger drop down for services JavaScript

    // Burger drop down for markets JavaScript
    const marketsDropDown = document.querySelector('.markets-drop-down-phone');
    const marketsDropDownContent = document.querySelector('.markets-drop-down-content-phone');
    const marketsDropDownArrow = document.querySelector('.markets-drop-down-arrow');

    marketsDropDown.addEventListener('click', () => {
      marketsDropDownContent.classList.toggle('active');
      marketsDropDownArrow.classList.toggle('rotate');
      //
      if(servicesDropDownContent.classList.contains('active')){
        servicesDropDownContent.classList.remove('active');
        servicesDropDownArrow.classList.remove('rotate');
      }
      else {
        return;
      }
    })
    // Burger drop down for markets JavaScript
    // Clients Say scripte
    const allTestemonialsImg = document.querySelectorAll('.testimonial-img');
    const allTestemonialsVideo = document.querySelectorAll('.testimonial-video');

    if(allTestemonialsImg.length === 0) {
      return;
    }
    else {
      allTestemonialsImg.forEach((element, idx) => {
        element.addEventListener('click', (e) => {
          e.target.style.display = 'none';
          // allTestemonialsVideo[idx].removeAttribute('sandbox');
          // console.log(allTestemonialsVideo[idx].getAttribute('data-src'));
          allTestemonialsVideo[idx].setAttribute('src', allTestemonialsVideo[idx].getAttribute('data-src'));
          allTestemonialsVideo[idx].style.display = 'block';

        })
      })
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // stop iframe

    // let iframe = document.querySelectorAll('iframe');
    
    // iframe.forEach((frame) => {
    //   frame.stop
    // })

    /* eslint-disable */
    // Select dropdown - Icon status
    const selectInput = document.querySelector('select');

    if (selectInput !== null) {
      selectInput.addEventListener('change', () => {
        selectInput.blur();
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js